import React from 'react'
import { DashboardContainer } from '@/components/containers/dashboard'
import { useTitle } from '@/hooks/use-title'
import HomeIcon from '@material-ui/icons/Home'

export const DashboardPage: React.FC = (props) => {
  useTitle('ホーム', <HomeIcon />)
  return <DashboardContainer {...props} />
}
